<template>
  <div class="custom-chip"
       :class="[editing ? 'custom-chip-selected' : '']"
       @click="$emit('click')">
    <slot></slot>
    <span v-if="!hideActions" style="display: flex; align-items: center">
      <v-icon @click="$emit('edit')"
              right
              small>
        mdi-pencil
      </v-icon>

      <v-icon @click="$emit('delete')"
              right
              small>
        mdi-close
      </v-icon>
    </span>
  </div>
</template>

<script>
export default {
  props: ['hideActions', 'editing']
}
</script>

<style>
  .custom-chip {
    background-color: #e4ffe0;
    border: solid 1px #4f8e62;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    margin: 2px 4px;
    padding: 8px 16px;
  }

  .custom-chip-selected {
    background-color: #fac0c8 !important;
    border: solid 1px #C92239 !important;
    transition: all .2s ease-in-out;
  }
</style>
